import React from "react";
import { Auth } from "aws-amplify";
import { RequireNewPassword } from "aws-amplify-react";
import PropTypes from "prop-types";
// Material Components
import Avatar from '@material-ui/core/Avatar';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import withStyles from '@material-ui/core/styles/withStyles';
//Custom Components
import LoaderButton from "../Buttons/LoaderButton"
// Auth Styles
import styles from "./AuthStyles"


class CustomRequireNewPassword extends RequireNewPassword {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
    this._validAuthStates = ['requireNewPassword'];
  }

  toSignIn = () => super.changeState("signIn");

  submit = async event => {
    event.preventDefault();
    const { newPassword } = this.inputs;

    this.setState({isLoading: true});
    try {
      await Auth.completeNewPassword(this.props.authData, newPassword);
      super.changeState("signIn");

    } catch (e) {
      this.error(e);
    }
    this.setState({isLoading: false});
  };

  showComponent(theme) {
    const { classes } = this.props;
    return (
      <main className={classes.main}>
        <Paper className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Nova Senha
          </Typography>

          {this.props.authData &&
            <form className={classes.form} onSubmit={this.submit}>

              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="password">Nova Senha</InputLabel>
                <Input
                  key="newPassword"
                  id="newPassword"
                  name="newPassword"
                  autoComplete="off"
                  type="password"
                  autoFocus
                  onChange={this.handleInputChange}
                />
              </FormControl>

              <div className={classes.submit}>
                <Link variant="body2" href="#" onClick={this.toSignIn}>Voltar</Link>
                <LoaderButton
                  type="submit"
                  isLoading={this.state.isLoading}
                  text="Confirmar"
                  loadingText="Confirmando..."
                  circularProgressProps={{size:22, thickness:4.5, color:"primary", classes:{root: classes.spinner}}}
                  variant="contained"
                  color="primary"
                />
              </div>

            </form>
          }
        </Paper>
      </main>
    )
  }
}

CustomRequireNewPassword.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CustomRequireNewPassword);
